import {
  GET_STICKY_COLUMNS,
  GET_STICKY_COLUMNS_SUCCESS,
  GET_STICKY_COLUMNS_ERROR,
  UPDATE_STICKY_COLUMNS,
  UPDATE_STICKY_COLUMNS_SUCCESS,
  UPDATE_STICKY_COLUMNS_ERROR
} from "./actionTypes"

const initialState = {
  error: null,
  admin_user_column_preference: null,
  loading: false
}

const adminUserColumnPreference = (state = initialState, action) => {
  switch (action.type) {
    case GET_STICKY_COLUMNS:
      return {
        ...state,
        loading: true
      }

    case GET_STICKY_COLUMNS_SUCCESS:
      return {
        ...state,
        admin_user_column_preference: action.payload,
        loading: false
      }

    case GET_STICKY_COLUMNS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case UPDATE_STICKY_COLUMNS:
      return {
        ...state,
        loading: true
      }

    case UPDATE_STICKY_COLUMNS_SUCCESS:
      return {
        ...state,
        admin_user_column_preference: action.payload,
        loading: false
      }

    case UPDATE_STICKY_COLUMNS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }
    default:
      return state
  }
}

export default adminUserColumnPreference;
